export default __webpack_public_path__ + "static/MediaContentTwoFancybox-98adc127a3a4c77eaaeb7de73e235c05.webp";